var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "600",
      "title": "编辑"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h3', [_vm._v("客户名")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedTechService ? _vm.openedTechService.customer.name : "") + " ")])]), _c('div', {
    staticClass: "item"
  }, [_c('h3', [_vm._v("状态")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedTechService ? _vm.openedTechService.status : "") + " ")])]), _c('div', {
    staticClass: "item"
  }, [_c('h3', [_vm._v("创建人")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedTechService ? _vm.openedTechService.createdBy.name : "") + " ")])]), _c('div', {
    staticClass: "item"
  }, [_c('h3', [_vm._v("指派的技术员")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedTechService ? _vm.openedTechService.createdBy.name : "") + " ")])]), _c('div', {
    staticClass: "item"
  }, [_c('h3', [_vm._v("实验内容")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedTechService ? _vm.openedTechService.content : "") + " ")])])]), _c('div', {
    staticClass: "content-right"
  }, [_c('h2', [_vm._v("销售项目")]), _vm._l(_vm.salesList, function (item) {
    return _c('div', {
      key: item._id
    }, [_c('h4', [_vm._v(_vm._s(item.abbr))]), _vm._l(item.recipe, function (recipe) {
      return _c('div', {
        key: recipe._id
      }, [_c('div', [_vm._v("#" + _vm._s(recipe.NoId) + " " + _vm._s(recipe.name))])]);
    })], 2);
  })], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }